import Box from '@mui/material/Box';
import BrandLogoMini from '@/assets/images/svg/LogoMini';
import { GET_WRAPPER_STYLES } from '@/components/Common/SideNav/Logo/Logo.utils';
import InternalAdminLogo from '@/assets/icons/InternalAdminLogo';

export default function Logo({ collapse }: { collapse: boolean }) {
  return (
    <Box sx={GET_WRAPPER_STYLES(collapse)}>
      {collapse ? <BrandLogoMini /> : <InternalAdminLogo />}
    </Box>
  );
}
